// extracted by mini-css-extract-plugin
export var card = "_j3-5";
export var cardSelected = "_j3-4";
export var image = "_j3-3";
export var modal = "_j3-0";
export var modalContent = "_j3-1";
export var table = "_j3-2";